import React, { useState } from "react";
import { formatIsoToCardDate } from "../../utils/general";
import "./LocationCard.scss";
import { ReactComponent as LocationPin } from "./../../assets/icons/location-icon.svg";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Location } from "../../services/LocationService";

interface LocationCardProps {
  data: Location;
  onEdit?: () => void;
  onDelete?: () => void;
  onView?: () => void;
}

const LocationCard: React.FC<LocationCardProps> = ({
  data,
  onEdit,
  onDelete,
  onView,
}) => {
  // const dropdownOptions = [
  //   { label: "Edit", value: "edit" },
  //   { label: "Delete", value: "delete" },
  //   { label: "View", value: "view" },
  // ];

  // const handleDropdownSelect = (value: string) => {
  //   if (value === "edit" && onEdit) onEdit();
  //   if (value === "delete" && onDelete) onDelete();
  //   if (value === "view" && onView) onView();
  // };
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (action: string) => {
    if (action === "edit" && onEdit) onEdit();
    if (action === "delete" && onDelete) onDelete();
    if (action === "view" && onView) onView();
    handleMenuClose();
  };
  return (
    <div className="location-card">
      {/* Header */}
      <div className="card-header">
        <h3 className="title">{data.name}</h3>
        <button className="menu-btn">
          <IconButton
            className="menu-btn"
            onClick={handleMenuClick}
            size="small"
          >
            <MoreHorizIcon />
          </IconButton>
          <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
            <MenuItem onClick={() => handleSelect("edit")}>Edit</MenuItem>
            <MenuItem onClick={() => handleSelect("delete")}>Delete</MenuItem>
            <MenuItem onClick={() => handleSelect("view")}>View</MenuItem>
          </Menu>
        </button>
        {/* <ButtonDropdown
          label=""
          options={dropdownOptions}
          onSelect={handleDropdownSelect}
        /> */}
      </div>

      {/* Body */}
      <div className="card-body">
        <div className="location-icon">
          <LocationPin />
        </div>
        <p className="address">{data.address}</p>
      </div>

      {/* Footer */}
      <div className="card-footer">
        <div className="footer-item">
          <span className="label">Created On</span>
          <span className="value">{formatIsoToCardDate(data.createdAt)}</span>
        </div>
        <div className="footer-item">
          <span className="label">Modified On</span>
          <span className="value">{formatIsoToCardDate(data.updatedAt)}</span>
        </div>
      </div>
    </div>
  );
};

export default LocationCard;
